<template>
  <div>
    <dx-grid
      url="buildings"
      :columns="columns"
      :actions="actions"
      :title="title"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      ref="grid"
    ></dx-grid>

    <v-dialog persistent v-model="editDialog" max-width="600">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">{{
          rowClicked.id ? "Update Building" : "Add Building"
        }}</v-card-title>

        <v-text-field
          class="mx-2"
          v-model="rowClicked.code"
          label="Code"
          ref="code"
          :rules="[rules.required]"
          counter="50"
          maxlength="50"
        ></v-text-field>

        <v-text-field
          class="mx-2"
          v-model="rowClicked.description"
          label="Description"
          ref="description"
          counter="50"
          maxlength="50"
        ></v-text-field>

        <v-text-field
          class="mx-2"
          v-model="rowClicked.descriptionH"
          label="Hebrew Description"
          ref="descriptionH"
          counter="100"
          maxlength="100"
        ></v-text-field>

        <v-text-field
          class="mx-2"
          v-model="rowClicked.recording"
          label="Recording"
        ></v-text-field>

        <v-layout row class="mx-2 mb-3" v-if="rowClicked.recording">
          <v-btn @click="rowClicked.recording = null" flat icon color="red">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <audio controls :src="rowClicked.recording"></audio>
        </v-layout>

        <v-layout row class="mx-2">
          <v-btn small outline :loading="uploading" @click="pickFile()">
            Upload Recording
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
          <input
            type="file"
            style="display: none"
            ref="files"
            accept=".mp3"
            @change="onFilePicked($event)"
          />
        </v-layout>

        <v-switch
          color="success"
          class="mt-4 mx-2"
          v-model="rowClicked.inactive"
          label="Inactive"
          hide-details
        ></v-switch>

        <v-card-actions class="mx-0 px-2 pb-2 mt-4">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="editDialog = false">Cancel</v-btn>
          <v-btn :loading="processing" color="success" @click="save()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Buildings",

    actions: [],

    editDialog: false,

    rowClicked: {
      id: 0,
      code: "",
      description: "",
      descriptionH: "",
      recording: "",
      inactive: false,
    },

    processing: false,
    uploading: false,

    columns: [
      {
        label: "ID",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Code",
        field: "code",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Description",
        field: "description",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Description",
        field: "descriptionH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Recording",
        template: "link-audio-cell-template",
        field: "recording",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Inactive",
        field: "inactive",
        visible: true,
        type: "boolean",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],

    rules: {
      required: (value) => !!value || "Required.",
    },
  }),

  created() {
    this.actions.push({
      text: "Add Building",
      action: this.addNew,
    });
  },

  methods: {
    onRowClicked(row) {
      this.rowClicked = JSON.parse(JSON.stringify(row));
      this.editDialog = true;
    },

    addNew() {
      this.rowClicked = {
        id: 0,
        code: "",
        description: "",
        descriptionH: "",
        recording: "",
        inactive: false,
      };
      this.editDialog = true;
    },

    pickFile() {
      this.$refs.files.click();
    },

    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();
        formData.append("upload_file", files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?convertMp3=true",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.rowClicked.recording = response.url;
        this.uploading = false;
      } catch (e) {
        this.uploading = false;
      }
    },

    async save() {
      if (!this.$refs.code.validate(true)) return;

      try {
        this.processing = true;

        await this.$http.post("api/buildings/Save", this.rowClicked);

        this.editDialog = false;
        this.processing = false;

        this.$refs.grid.reloadGrid();

        this.$notify({
          type: "success",
          group: "notification",
          text: "Building saved successfully",
        });
      } catch (e) {
        this.processing = false;
        this.$notify({
          type: "error",
          group: "notification",
          text: "Failed to save building",
        });
      }
    },
  },
};
</script>
